
<template>
  <ConversionMonnaie />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import ConversionMonnaie from "@/components/GesCom/Operations/ConversionMonnaie.vue";
import BreadCrumbs from "@/layout/BreadCrumbs.vue";

export default defineComponent({
  name: "ConversionMonnaiePage",
  components: {
    BreadCrumbs,
    ConversionMonnaie,
  },
});
</script>

